<template>
<bim-row id="faq" class="services-lending__questions" justify="center">
  <bim-col class="services-lending__info-title" cols="12">Остались вопросы?</bim-col>
  <bim-col cols="12" sm="9">
    <div class="software-question faq-dropdown" v-for="(item, index) in faq" :key="index">
      <div  v-metric="'LENDING-BIM_CLICK-ON-FAQ'" class="faq-dropdown_top">
        <p class="faq-dropdown_title">{{item.question}}</p>
        <i class="icon-dropdown-light"></i>
      </div>
      <div class="faq-dropdown_content">
        <p>{{item.answer}}</p>
      </div>
    </div>
  </bim-col>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import { mapState } from 'vuex'

export default {
  name: "block-questions",
  components: {
    bimCol,
    bimRow,
  },
  computed: {
    ...mapState('counters', [
      'project_smpp_count'
    ]),
    faq() {
      return [
        {
          question: "Сколько проектов загружено в базу?",
          answer: `${this.project_smpp_count}, и цифра постоянно растёт, так как мы получаем информацию ежедневно от сообщества сметчиков с общим числом более 1000 специалистов.`
        },
        {
          question: "Каковы источники информации по строящимся объектам?",
          answer: "Данные агрегированы из открытых источников (ИСОГД, госзакупки, Общество взаимного страхования застройщиков). В режиме онлайн данные пополняются из опубликованных на платформе  различных источников. "
        },
        {
          question: "Откуда берется информация по проектной потребности на объекте?",
          answer: "Мы получаем информацию из различных источников. Платформа является гарантом её полноты и корректности."
        },
        {
          question: "Как быстро растет база новых проектов?",
          answer: "Количество новых объектов строительства и их проектные потребности пополняются в режиме онлайн, и зависит от текущего состояния строительной отрасли. Мы стараемся добавлять для вас не менее десяти крупных объектов в месяц."
        },
        {
          question: "Насколько актуальны контактные данные и как их проверяете?",
          answer: "Данные из различных источников, и их актуальность проверяется по запросу."
        }
      ]
    }
  },
}
</script>
